import { breakpoints, Image } from '@gassan-ui'
import React, { FC, HTMLAttributes, useEffect, useRef } from 'react'
import styled from 'styled-components'

const StyledImage = styled(Image)<{ variant: string }>`
  transition: opacity 0.3s ease;
  cursor: ${p => p.variant === 'default' && 'zoom-in'};
  img {
    object-position: ${p => (p.variant === 'default' ? 'top center' : 'center center')};
    @media screen and (min-width: ${breakpoints.small}) {
      object-position: center center;
    }
  }
`

type Props = HTMLAttributes<HTMLDivElement> & {
  isActive: boolean
  sources: string[]
  placeholderSrc: string
  variant?: 'default' | 'fullscreen'
  title: string
}

const Slide: FC<Props> = ({
  isActive,
  sources,
  placeholderSrc,
  variant = 'default',
  title,
  ...rest
}) => {
  const hasBeenActive = useRef(false)
  useEffect(() => {
    if (isActive && !hasBeenActive.current) {
      hasBeenActive.current = true
    }
  }, [isActive])

  return (
    <StyledImage
      {...rest}
      alt={title}
      variant={variant}
      sources={sources}
      placeholderSrc={placeholderSrc}
      width="100%"
      height="100%"
      top={0}
      left={0}
      position="absolute"
      objectFit="contain"
      loading={hasBeenActive.current === true || isActive ? 'lazy' : 'none'}
      backgroundColor="shades.50"
      opacity={isActive ? 1 : 0}
    />
  )
}

export default Slide
